import mori from 'mori';
import buildTableData
  from '../../../datacenter/app/js/services/tableData';
import getFootnotes from '../../../datacenter/app/js/services/getFootnotes/';
import footnoteCallback from '../../../datacenter/app/js/services/getFootnotes/footnoteCallback';
import buildMapFromTimeframe
  from '../../../datacenter/app/js/services/mapData';
import getSelectedDistributions
  from '../../../datacenter/app/js/services/getSelectedDistributions';

/**
 * Update map/table data as needed
 * @param  {Object} state current state, needs to have filteredData,
 *                        combinedFilter, isMultiGeo, type attached
 * @return {Object}       data updates
 */
export default function updateData(state, update = {}) {
  const tableProps = {};
  let datamapProps = null;
  const {
    filteredData,
    combinedFilters,
    isMultiGeo,
    type,
  } = state;

  if (!filteredData || !combinedFilters || !type) {
    /* eslint-disable */
    console.error = console.error || console.log || function log() {};
    console.error('Something happened, updateData() should only be called after data has been ran loaded properly');
    /* eslint-enable */
    return {};
  }

  // Currently footnotes on data export is not implemented.
  // That said, we need to get the footnotes at least setup so data
  // will render correctly in downloadCSV.js
  const footnotes = getFootnotes(
    state,
    update,
    filteredData,
    combinedFilters
  );

  function footnoteCb(key) {
    return footnoteCallback(
      key,
      footnotes.labeledFootnotes,
      !!(update.currentTimeframe && update.startTimeframe)
    );
  }

  tableProps.footnoteCallback = footnoteCb;

  if ('all' === type || 'table' === type) {
    buildTableData.bind(tableProps)(
      state,
      update,
      filteredData,
      [
        mori.set(), // All columns
        mori.concat(
          mori.vector(state.combinedFilters[4][0]),
          getSelectedDistributions(
            state,
            state.immutableDistributions,
            state.globalSettings.hasDataviews &&
              !mori.getIn(state.config, ['globalRules', 'Locked'], false) ?
                mori.nth(state.immutableDataviews, 0) :
                false
          )),
        state.immutableDistributions,
        combinedFilters[3],
        combinedFilters[4],
      ],
      () => {}, // Ready callback... (not neede right now)
      combinedFilters[0], // Selected Keys
      isMultiGeo,
      () => {} // render.getFootnotes
    );
  }

  if ('all' === type || 'map' === type) {
    datamapProps = buildMapFromTimeframe(
      state,
      update,
      false, // Represents the treeContextSlug in Datacenter - not needed here.
      filteredData,
      ...state.combinedFilters
    );
  }
  return {
    table: tableProps,
    datamap: datamapProps,
  };
}



// WEBPACK FOOTER //
// ./app/services/updateData.js